'use strict';

const Web3Modal = window.Web3Modal.default;
const WalletConnectProvider = window.WalletConnectProvider.default;

const $html = $('html');
const $overlay = $('.overlay');
const $connectBtn = $('#connectBtn');

(() => {
    var app = {
        tokenContractAddress: '0x6fb1e018f107d3352506c23777e4cd62e063584a',
        stakingContractAddress: '0xf5fb6f85378130e92a1aec39ae2d9a095beb5280',

        web3: null,
        web3Modal: null,
        provider: null,
        account: null,

        rewardsInterval: null,

        allowance: 0,
    
        init: () => {
            $('html, body').animate({ scrollTop: 0 });
            
            const providerOptions = {
                walletconnect: {
                    package: WalletConnectProvider,
                    options: {
                        rpc: {
                            1: 'https://main-light.eth.linkpool.io/',
                            56: 'https://bsc-dataseed1.binance.org:443',
                            97: 'https://data-seed-prebsc-1-s1.binance.org:8545'
                        }
                    }
                }
            };
            
            app.web3Modal = new Web3Modal({
                cacheProvider: false,
                providerOptions,
                disableInjectedProvider: false
            });

            $connectBtn.prop('disabled', false);
            $connectBtn.click(() => { app.onConnect() });
        },

        initContracts: () => {
            $.getJSON('/contracts/token.json', (data) => {
                app.token = new app.web3.eth.Contract(data, app.tokenContractAddress, {from: app.account});
            });
        
            $.getJSON('/contracts/staking.json', (data) => {
                app.staking = new app.web3.eth.Contract(data, app.stakingContractAddress, {from: app.account});
                
                app.handleGetFees();
                app.handleGetDeposits();
            });

            app.showOverlay('Connected', true);

            setTimeout(() => {
                app.hideOverlay();
            }, 500);
        },

        handleGetFees: () => {
            app.staking.methods.getFees().call().then((fees) => {
                for (var i = 0; i < fees.length; i++) {
                    var $stakeItem = $('.stake__item--' + (i + 1));
                    var $fees = $stakeItem.find('.fees i');
                    var $days = $stakeItem.find('.days i');

                    var feesText = (app.web3.utils.fromWei(fees[i].fee, 'ether') * 100).toFixed(0);
                    var daysText = app.web3.utils.fromWei(fees[i].time, 'wei') / (24 * 3600);
                    
                    $fees.text(`${feesText}%`);
                    $days.text(`${daysText} days`);
                    
                    $stakeItem.find('.btn-deposit').attr('data-days', daysText);
                }

                app.handleGetAllowance();

                $('.btn-deposit').click(function() {
                    var amount = $(this).parent().find('input').val();
                    var days = $(this).data('days');

                    if (amount) {
                        if (app.allowance >= amount) {
                            app.handleDeposit(amount, days);
                        } else {
                            app.handleApprove(amount, days);
                        }
                        
                        return false;
                    }
                });
            }).catch((err) => {
                console.log(err.message);
            });
        },

        getReward: (deposit, now) => {
            return deposit.startTime + deposit.time > now ? 0 : app.web3.utils.fromWei(deposit.amount) * app.web3.utils.fromWei(deposit.fee) * (now - deposit.startTime) / (365 * 24 * 3600);
        },

        handleGetDeposits: () => {
            app.staking.methods.getDeposits().call().then((result) => {
                var deposits = result[0];
                var now = result[1];
                
                deposits = deposits.map((obj, idx) => ({ ...obj, id: idx }));
                deposits = deposits.slice().sort((a, b) => a.startTime - b.startTime);
                
                $('.stake__pools-list').html('');

                for (var i = 0; i < deposits.length; i++) {
                    $('.stake__pools-list').append('<ul class="stake__pools-item">'+
                        `<li>${deposits[i].time / (24 * 3600) + ' days'}</li>`+
                        `<li>${new Date(deposits[i].startTime * 1000).toLocaleDateString("en-US")}</li>`+
                        `<li>${new Date((parseInt(deposits[i].startTime) + parseInt(deposits[i].time)) * 1000).toLocaleDateString("en-US")}</li>`+
                        `<li>${(app.web3.utils.fromWei(deposits[i].fee, 'ether') * 100).toFixed(0) + '%'}</li>`+
                        `<li>${app.web3.utils.fromWei(deposits[i].amount, 'ether')}</li>`+
                        `<li class="reward-${i}">${app.getReward(deposits[i], now).toFixed(5)}</li>`+
                        `<li><div class="btn btn-withdraw" data-id='${deposits[i].id}' data-time-right=${deposits[i].startTime} data-time=${deposits[i].time}>Withdraw</div></li>`+
                    '</ul>');
                }

                if (app.rewardsInterval) {
                    clearInterval(app.rewardsInterval);
                }
                
                app.rewardsInterval = setInterval(() => {
                    var time = new Date().getTime() / 1000;

                    for (var i = 0; i < deposits.length; i++) {
                        $(`.reward-${i}`).text(app.getReward(deposits[i], `${time}`).toFixed(5));
                    }
                }, 1000);

                deposits.length ? $('.stake__title--2').show() : $('.stake__title--2').hide();
                deposits.length ? $('.stake__pools').show() : $('.stake__pools').hide();

                $('.stake__item').find('input').val('');

                $('.btn-withdraw').click(function() {
                    var id = `${$(this).data('id')}`;
                    var time = `${$(this).data('time')}`;

                    if (confirm('Do you confirm this action?')) {
                        app.handleWithdraw(id, time);
                    }
                });
            }).catch((err) => {
                console.log(err.message);
            });
        },

        handleGetAllowance: () => {
            app.token.methods.allowance(app.account, app.stakingContractAddress).call().then((amount) => {
                app.allowance = app.web3.utils.fromWei(amount, 'ether');
            }).catch((err) => {
                console.log(err.message);
            });
        },

        handleApprove: (amount, days) => {
            app.showOverlay('Please wait...', false, true);
            
            app.token.methods.approve(app.stakingContractAddress, app.web3.utils.toWei(amount, 'ether')).send().then((result) => {
                if (result) {
                    app.handleDeposit(amount, days);
                }
            }).catch((err) => {
                console.log(err.message);

                app.showOverlay('Transaction declined', true);

                setTimeout(() => {
                    app.hideOverlay();
                }, 500);
            });
        },

        handleDeposit: (amount, days) => {
            app.showOverlay('Please wait...', false, true);

            app.staking.methods.deposit(app.web3.utils.toWei(amount, 'ether'), app.web3.utils.toWei('' + (days * 24 * 3600), 'wei')).send().then(function(result) {
                if (result) {
                    app.showOverlay('Transaction confirmed', true);

                    app.handleGetDeposits();

                    setTimeout(() => {
                        app.hideOverlay();
                    }, 500);
                }
            }).catch((err) => {
                console.log(err.message);

                app.showOverlay('Transaction declined', true);

                setTimeout(() => {
                    app.hideOverlay();
                }, 500);
            });
        },

        handleWithdraw: (id, time) => {
            app.showOverlay('Please wait...', false, true);

            app.staking.methods.withdraw(app.web3.utils.toWei(id, 'wei'), time).send().then((result) => {
                if (result) {
                    app.showOverlay('Transaction confirmed', true);

                    app.handleGetDeposits();

                    setTimeout(() => {
                        app.hideOverlay();
                    }, 500);
                }
            }).catch((err) => {
                console.log(err.message);

                app.showOverlay('Transaction declined', true);

                setTimeout(() => {
                    app.hideOverlay();
                }, 500);
            });
        },

        fetchAccountData: async () => {
            app.web3 = new Web3(app.provider);

            const accounts = await app.web3.eth.getAccounts();
            const chainId = await app.web3.eth.getChainId();

            app.account = accounts[0];

            if (chainId != 1 && chainId != 56 && chainId != 97) {
                app.showOverlay('Ethereum Mainnet or Binance Smart Chain<br>network required', true);
                return;
            }

            app.initContracts();
        },

        refreshAccountData: () => {
            window.location.reload();
        },

        onConnect: async () => {
            try {
                app.provider = await app.web3Modal.connect();
            } catch(e) {
                console.log('Could not get a wallet connection:', e);
                return;
            }
            
            app.provider.on('accountsChanged', (accounts) => {
                app.refreshAccountData();
            });

            app.provider.on('chainChanged', (chainId) => {
                app.refreshAccountData();
            });

            app.provider.on('networkChanged', (networkId) => {
                app.refreshAccountData();
            });
            
            $connectBtn.prop('disabled', true);
            
            await app.fetchAccountData();
        },

        showOverlay: (title, hideBtn, toggleBtn) => {
            $html.addClass('page-disabled');
            $overlay.show();

            if (title) {
                $overlay.find('.title').html(title);
            }

            hideBtn ? $connectBtn.addClass('hidden') : $connectBtn.removeClass('hidden');

            $connectBtn.prop('disabled', toggleBtn);
        },

        hideOverlay: () => {
            $html.removeClass('page-disabled');
            $overlay.hide();
        }
    };

    window.app = app;
    app.init();
})();